// import { ClickBox } from '../components/GeneralComponent'
import styled from 'styled-components'
import { useNavigate } from 'react-router-dom'
import { useTranslation } from 'react-i18next';

const BackStageHome = () => {
    const { t } = useTranslation('translation', { keyPrefix: 'library.home' });
    console.log();
    const navigate = useNavigate()

    const handleClickBox = (value) => {
        console.log(value)
        navigate('/library/backstage' + value)
    }

    return (
        <MainContainer>
            {/* <ClickBox onClick={e => handleClickBox('/Cataloging')} >
                {t('cataloging')}
            </ClickBox>
            <ClickBox onClick={e => handleClickBox('/Circulation')} >
                {t('circulation')}
            </ClickBox>
            <ClickBox onClick={e => handleClickBox('/Patrons')} >
                {t('patrons')}
            </ClickBox> */}
            {/* <div style={{...ClickBoxStyle}} onClick={e => handleClickBox('/Cataloging')}  >
                111
            </div> */}
        </MainContainer>
    )
}

const MainContainer = styled.div`
width: 100%;
display: flex;
justify-content: center;
flex-direction: column;
align-items: center;
padding: 2em;
gap: 0.5em;
`

const ClickBox = styled.div`
padding: 0.2em;
background-color: rgb(221, 241, 249);
border-radius: 0.5em;
width: 10em;
font-size: 1.2em;
cursor: pointer;
`

const ClickBoxStyle = {
    padding: '0.2em',
    backgroundColor: 'rgb(221, 241, 249)',
    borderRadius: '0.5em',
    width: '10em',
    fontSize: '1.2em',
    cursor: 'pointer',
}

export default BackStageHome